import { render, staticRenderFns } from "./company_list.vue?vue&type=template&id=2ff54d10&"
import script from "./company_list.vue?vue&type=script&lang=js&"
export * from "./company_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/oem/work/Rails/tosdere_erp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2ff54d10', component.options)
    } else {
      api.reload('2ff54d10', component.options)
    }
    module.hot.accept("./company_list.vue?vue&type=template&id=2ff54d10&", function () {
      api.rerender('2ff54d10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/admin/company/company_list.vue"
export default component.exports